export enum AssetTypeUIMessages {
  LOAD_ASSET_TYPE_LIST_ERROR = 'An error occurred while loading the list of Asset Types.',
  LOAD_ASSET_TYPE_ERROR = 'An error occurred while loading the Asset Type.',
  ADD_ASSET_TYPE_SUCCESS = 'Asset Type successfully created.',
  ADD_ASSET_TYPE_ERROR = 'An error occurred while creating the Asset Type.',
  EDIT_ASSET_TYPE_SUCCESS = 'Asset Type successfully updated.',
  EDIT_ASSET_TYPE_ERROR = 'An error occurred while updating the Asset Type.'
}
